.tooltip {
  position: fixed;
  z-index: 60;
  max-width: min(320px, calc(100vw - 16px));
  padding: 4px 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--surface);
  box-shadow: var(--shadow-pop);
  color: var(--text);
  font-size: var(--font-size-sm);
  line-height: 1.4;
  font-variant-numeric: tabular-nums;
  /* A learning tip carries its gesture hint on a second line ("\n" in the text, §3.6.2). */
  white-space: pre-line;
  pointer-events: none;
}
